"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const sendLoggingEvent_1 = require("../libs/logging/helpers/sendLoggingEvent");
const loggingTypes_1 = require("../libs/logging/types/loggingTypes");
const constants_1 = require("../constants");
const helpers_1 = require("../helpers");
const AppContextProvider_1 = require("../contexts/AppContextProvider");
const useScreenLoadLogging = (currentScreenName) => {
    const cookies = (0, helpers_1.parseCookies)();
    const { flowState } = (0, AppContextProvider_1.useSsoContext)();
    (0, react_1.useEffect)(() => {
        var _a;
        (0, sendLoggingEvent_1.sendLoggingEvent)({
            actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.SCREEN,
            actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.LOAD,
            actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
            currentScreenName,
            ux_type: loggingTypes_1.EnumUxTypes.SCREEN,
            memberId: ((_a = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _a === void 0 ? void 0 : _a.id) || null,
            sessionFunnel: false
        }).then(() => {
            let prev = cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME] ?
                cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME].split(",") : [loggingTypes_1.EnumLoggingScreenNames.NA];
            // previous
            if (prev[prev.length - 1] != currentScreenName) {
                prev = [prev[prev.length - 1], currentScreenName];
                (0, helpers_1.setCookie)(constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME, prev.join(","));
            }
        });
    }, []);
};
exports.default = useScreenLoadLogging;
